import FJUtil from '../../util/FJUtil';
import FJMessageStore from '../../store/FJMessageStore';
import FJLocalStore from '../../store/FJLocalStore';
import {
    setSlicePeopleImageInfoAction,
    setSliceClothesImageInfoAction,
    setSliceSelectedStyleAction,
    setSliceClothesInfoAction,
    setSliceTabAction,
    setSliceSelectedModelAction,
    DEFAULT_MODEL,
    setSliceIsUploadingAction,
} from '../slices/FJSliceClothesChanger';
import FJNetworkStore from '../../store/FJNetworkStore';
import FJActionModal from './FJActionModal';
import FJActionCommon from './FJActionCommon';
import { UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE } from '../../config/dataConfig/FJGenerateData';
import { setSliceCreationListAction, setSliceTaskStatusAction } from '../slices/FJSliceCommon';
import FJConstant from '../../constants/FJConstant';
import FJImageStore from '../../store/FJImageStore';
import FJCompressedImageStore from '../../store/FJCompressedImageStore';
import FJAppConstant from '../../constants/FJAppConstant.js';
import {
    CLOTHES_CHANGER_MODEL_LIST,
    NEW_CLOTHES_CHANGER_STYLE_LIST,
} from '../../config/dataConfig/FJClothesChangerData';
import { MAX_COMPRESS_IMAGE_SIZE } from '../../config/dataConfig/FJGenerateData.js';
import FJConfig from '../../config/FJConfig.js';

let f_eventId = null;

const _getImageUrl = name => {
    return FJConfig.stylePath + name + `?v=${FJConfig.version}`;
};

// 找到是否是用了我们自己的资源，并返回对应的分类
const _findCategoryV2 = name => {
    const _list = [...NEW_CLOTHES_CHANGER_STYLE_LIST.male, ...NEW_CLOTHES_CHANGER_STYLE_LIST.female];
    const selectedCategory = _list.find(categoryData => {
        return categoryData.clothes.findIndex(item => item.key === name) !== -1;
    });

    return selectedCategory ? selectedCategory.categoryName : null;
};

const _clothesChangerAction = options => {
    return async (dispatch, getState) => {
        const { peopleImageInfo, clothesImageInfo, clothesInfo, model } = options;
        let { creditNumber, freeNumCreation } = getState().common;
        const selectedStyle = clothesInfo.key;
        const currentPrice =
            CLOTHES_CHANGER_MODEL_LIST.find(item => item.value === model)?.price || DEFAULT_MODEL.price;

        // const currentTaskId = new Date().getTime();
        // let _startTime = new Date().getTime();
        const __errorAndClear = () => {
            dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
            dispatch(setSliceCreationListAction([]));
        };
        const __errorAndReLoad = () => {
            const creationList = getState().common.creationList;
            const reLoadList = creationList.map(i => ({
                ...i,
                isLoading: false,
                isReload: true,
            }));
            dispatch(setSliceCreationListAction(reLoadList));
            dispatch(setSliceTaskStatusAction(FJConstant.ERROR));
        };
        //1.判断是否上传图片
        if (!peopleImageInfo.src || !clothesImageInfo.src) {
            FJMessageStore.addMessage(FJLocalStore._('please-upload-a-photo-or-clothes-image-first'), 'error');
            return;
        }
        //2.开始状态修改
        const placeHolderList = FJUtil.createPlaceHolderList({
            count: 1,
            uploadImageInfo: peopleImageInfo,
            generateInfo: {
                peopleImageInfo,
                clothesImageInfo,
                clothesInfo,
                model,
            },
        });
        dispatch(setSliceCreationListAction(placeHolderList));
        dispatch(setSliceTaskStatusAction(FJConstant.START));

        //3.判断登陆
        const userSpaceType = await FJUtil.checkUserSpace();
        if (userSpaceType > 0) {
            dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
            __errorAndClear();
            return;
        }

        /**
         * 4.额度判断 - 根据模型类型实现不同的检查策略
         */
        const isDoubaoModel = model === 'doubao'; // Max模型
        const isFalModel = model === 'fal'; // Pro模型

        let shouldShowUpgradeModal = false;
        let isFree = false;

        if (isDoubaoModel) {
            // doubao Max模型：无免费次数，只检查积分
            if (creditNumber < currentPrice) {
                shouldShowUpgradeModal = true;
            } else {
                isFree = false; // 使用积分
            }
        } else if (isFalModel) {
            // fal模型：需要判断是否还有免费次数
            if (creditNumber < currentPrice && !freeNumCreation) {
                shouldShowUpgradeModal = true;
            } else if (creditNumber < currentPrice && freeNumCreation) {
                isFree = true; // 使用免费次数
            } else {
                isFree = false; // 使用积分
            }
        } else {
            // 其他模型：默认逻辑
            if (creditNumber < currentPrice && !freeNumCreation) {
                shouldShowUpgradeModal = true;
            } else if (creditNumber < currentPrice && freeNumCreation) {
                isFree = true;
            } else {
                isFree = false;
            }
        }

        if (shouldShowUpgradeModal) {
            dispatch(FJActionModal.showUpgradeModalAction());
            __errorAndClear();
            return;
        }

        try {
            //5.上传s3
            const urls = [peopleImageInfo.src, clothesImageInfo.src];
            const imageS3UrlList = await FJImageStore.uploadFilesByUrl(urls);
            if (!imageS3UrlList || getState().common.appType !== FJAppConstant.CLOTHES_CHANGER) {
                __errorAndClear();
                return;
            }

            const __request = async () => {
                return await FJNetworkStore.clothesChanger({
                    image: imageS3UrlList[0],
                    garment: imageS3UrlList[1],
                    model_type: model,
                });
            };
            //6.创建任务
            f_eventId = await FJActionCommon.createRequestTask(__request, dispatch);
            if (!f_eventId) {
                __errorAndClear();
                return;
            }
            // 积分冻结
            FJUtil.updateAllCreditInfo(isFree);
            const tool = FJUtil.getToolName();
            FJUtil.eaLog('ai tool start generating', { 'credit&free': isFree ? 'free' : 'credit', tool });
            //7.轮询任务状态
            const __callback = data => {
                const { type, errorMessage } = data;
                if (type === FJConstant.ERROR) {
                    switch (errorMessage) {
                        case 50215:
                            FJMessageStore.addMessage(FJLocalStore._('50215-failure-return'), 'error');
                            break;
                        case 60102:
                            FJMessageStore.addMessage(FJLocalStore._('60102-failure-return'), 'error');
                            break;
                        case 60208:
                            FJMessageStore.addMessage(FJLocalStore._('60208-failure-return'), 'error');
                            break;
                        default:
                            FJMessageStore.addMessage(FJLocalStore._('failed-to-generate-clothes-change'), 'error');
                            break;
                    }
                    __errorAndReLoad();
                } else if (type === FJConstant.SUCCESS) {
                    FJUtil.eaLog('ai tool generate success', {
                        tool: FJUtil.getToolName(),
                        'credit&free': isFree ? 'free' : 'credit',
                    });

                    try {
                        const category = _findCategoryV2(selectedStyle);
                        const logData = {
                            page: window.isEditPage ? 'editor' : 'tools page',
                        };
                        if (category) {
                            logData.category = category;
                            logData['preset name'] = selectedStyle;
                            logData['model'] = isDoubaoModel ? 'max' : 'pro';
                        }
                        FJUtil.eaLog('clothes changer generate success', logData);
                    } catch (e) {
                        console.log(e);
                    }
                }
            };
            dispatch(
                FJActionCommon.pollingTaskAction([f_eventId], {
                    callback: __callback,
                    isUseFree: isFree,
                }),
            );
        } catch (e) {
            switch (e.cause) {
                case 50215:
                    FJMessageStore.addMessage(FJLocalStore._('50215-failure-return'), 'error');
                    break;
                case 60102:
                    FJMessageStore.addMessage(FJLocalStore._('60102-failure-return'), 'error');
                    break;
                case 60208:
                    FJMessageStore.addMessage(FJLocalStore._('60208-failure-return'), 'error');
                    break;
                default:
                    FJMessageStore.addMessage(FJLocalStore._('failed-to-generate-clothes-change'), 'error');
                    break;
            }

            __errorAndReLoad();
        }
    };
};

const FJActionClothesChanger = {
    resetAction: function () {
        return dispatch => {
            dispatch(setSliceClothesImageInfoAction({}));
            dispatch(setSlicePeopleImageInfoAction({}));
        };
    },
    uploadImageAction: function (file, isClothesImage = false, clearSelectStyle = true, skipTranscoded = false) {
        return async dispatch => {
            const isImage = FJUtil.isImage(file, true, UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE);

            const _processFile = async file => {
                const imageData = await FJCompressedImageStore.compressImageByFile(file);
                if (imageData) {
                    isClothesImage
                        ? dispatch(setSliceClothesImageInfoAction(imageData))
                        : dispatch(setSlicePeopleImageInfoAction(imageData));
                    if (isClothesImage && clearSelectStyle) {
                        dispatch(setSliceSelectedStyleAction(''));
                    }
                } else {
                    FJMessageStore.addMessage(
                        FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                        'error',
                    );
                }
            };

            if (!isImage) {
                if (skipTranscoded) {
                    FJMessageStore.addMessage(
                        FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                        'error',
                    );
                    return;
                }
                // 使用转码功能
                try {
                    const result = await dispatch(
                        FJActionModal.showCloudTranscodingModalAction({
                            files: [file],
                            mediaType: 'image',
                            outputFormat: 'png',
                            onReupload: newFiles => {
                                if (newFiles && newFiles.length > 0) {
                                    // 重新上传文件
                                    dispatch(this.uploadImageAction(newFiles[0]));
                                }
                            },
                        }),
                    );
                    // 直接使用转码后的文件
                    const transcodedFile = result.files[0];
                    _processFile(transcodedFile);
                } catch (e) {
                    if (e.cause === FJConstant.INVALID) {
                        FJMessageStore.addMessage(
                            FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                            'error',
                        );
                    }
                    if (e.cause === FJConstant.CANCELLED) return;
                }
            } else {
                _processFile(file);
            }
        };
    },
    uploadImageUrlAction: function (url, options = {}) {
        return async dispatch => {
            const { size, name, id, isClothesImage } = options;
            let data;
            if (size && (size.width > MAX_COMPRESS_IMAGE_SIZE || size.height > MAX_COMPRESS_IMAGE_SIZE)) {
                data = await FJCompressedImageStore.compressImageByUrl(url, { name: name }).catch(() => {
                    throw new Error('compress image failed');
                });
            } else {
                data = { name: name, src: url, width: size.width, height: size.height, id: id };
            }
            isClothesImage
                ? dispatch(setSliceClothesImageInfoAction(data))
                : dispatch(setSlicePeopleImageInfoAction(data));
            if (isClothesImage) {
                dispatch(setSliceSelectedStyleAction(''));
            }
        };
    },

    clearImageAction: function (isClothesImage = false) {
        return async dispatch => {
            isClothesImage ? dispatch(setSliceClothesImageInfoAction({})) : dispatch(setSlicePeopleImageInfoAction({}));
        };
    },

    /**
     * @deprecated 选中由我们提供的服装
     */
    selectClothesAction: function (name, imgSrc, applyDoneCallback) {
        return async (dispatch, getState) => {
            dispatch(setSliceSelectedStyleAction(name));
            const blob = await FJUtil.getBlobByUrl(imgSrc);
            if (!blob) {
                if (applyDoneCallback) applyDoneCallback();
                FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
                return;
            }
            if (applyDoneCallback) applyDoneCallback();
            if (getState().clothesChanger.selectedStyle !== name) return;
            const file = new File([blob], 'image.png', { type: 'image/png' });
            dispatch(FJActionClothesChanger.uploadImageAction(file, true, false, true));
        };
    },

    // 选中由我们提供的服装
    setClothesInfoAction: function (clothesInfo, callback) {
        return async dispatch => {
            try {
                dispatch(setSliceIsUploadingAction(true));
                const imgUrl = _getImageUrl(clothesInfo.filename);
                const blob = await FJUtil.getBlobByUrl(imgUrl);
                if (!blob) {
                    callback?.();
                    FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
                    dispatch(setSliceIsUploadingAction(false));
                    return;
                }
                const file = new File([blob], 'image.png', { type: 'image/png' });
                await dispatch(FJActionClothesChanger.uploadImageAction(file, true, false));
                dispatch(setSliceClothesInfoAction(clothesInfo));
                callback?.();
            } finally {
                dispatch(setSliceIsUploadingAction(false));
            }
        };
    },

    setTabAction: function (tab) {
        return async dispatch => {
            dispatch(setSliceTabAction(tab));
        };
    },

    generateAction: function () {
        return async (dispatch, getState) => {
            const { peopleImageInfo, clothesImageInfo, clothesInfo, selectedModel, isUploading } =
                getState().clothesChanger;
            const data = {
                peopleImageInfo,
                clothesImageInfo,
                clothesInfo,
                model: selectedModel,
            };

            FJUtil.eaLog('clothes changer generate click');
            if (isUploading) {
                return;
            }

            dispatch(_clothesChangerAction(data));
        };
    },

    cancelTaskAction: function () {
        return async dispatch => {
            try {
                f_eventId && (await FJNetworkStore.cancelTask(f_eventId));
            } catch (e) {
                FJMessageStore.addMessage(FJLocalStore._('cancel-to-delete-please-try-again'), 'error');
            } finally {
                dispatch(setSliceCreationListAction([]));
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
            }
        };
    },
    reGenerateAction: function (id) {
        return async (dispatch, getState) => {
            const { creationList } = getState().common;
            const item = creationList.find(item => item.id === id);
            const data = item.generateInfo;
            dispatch(_clothesChangerAction(data));
        };
    },

    initClothesImageAction: function () {
        return async dispatch => {
            if (window.isEditPage) return;
            const recId = FJUtil.getQueryString(FJConstant.REC_ID);
            const recIdInfo = recId ? JSON.parse(window.localStorage.getItem(recId)) : null;
            if (recIdInfo) {
                window.localStorage.removeItem(recId);
                const { url, width, height, id, name } = recIdInfo;
                if (url) {
                    dispatch(
                        FJActionClothesChanger.uploadImageUrlAction(url, {
                            size: { width, height },
                            id,
                            name,
                            isClothesImage: true,
                        }),
                    );
                }
            }
        };
    },
    // 设置选中的模型
    setSelectedModelAction: function (model) {
        return dispatch => {
            dispatch(setSliceSelectedModelAction(model));
        };
    },

    /**
     * @description 下载创作
     */
    downloadAllCreationAction: function (callback) {
        return async (dispatch, getState) => {
            const { creationList } = getState().common;
            if (creationList.length === 0) return;
            const ids = creationList.map(item => item.id);
            dispatch(FJActionCommon.multiDownloadAction(ids, 'creation', callback));
        };
    },
};
export default FJActionClothesChanger;
